import { App, defineAsyncComponent } from "vue";
import { kebabCase } from "lodash-es";

/**
 * @description require.context MUST have a static path, because it needs to extract file paths at transpile-time (not
 * at run-time!). The import statements must also start with a bit of static path - transpilation starts to behave very
 * irregular when it doesn't - and since it sort of ignores the RegEx, it must be suffixed with `.vue`.
 * Ideally, there would be less duplicate code, but it seems like this is the best we can do, for now.
 *
 * Also, note that the reason that (sub)theme-specific components are not loaded here is because Webpack will fail over
 * TailwindCSS classes that are present in one theme but not the other. Because the `require` approach loads all the
 * components, it will also load components that are not registered on the Vue instance (discarded), hence this
 * behaviour.
 *
 * @param app
 * @param alreadyRegisteredList
 */
export default function loadComponents(app: App<Element>, alreadyRegisteredList: string[] = []) {
    // Load the components from the base theme
    require
        .context("./components", true, /\.vue$/i, "lazy")
        .keys()
        .forEach((fullComponentPath: string) => {
            const componentPath = fullComponentPath.substring(2, fullComponentPath.length - 4);
            const componentName = kebabCase(fullComponentPath.split("/").pop().split(".")[0]);

            // If a component with this name has not already been registered
            if (alreadyRegisteredList.includes(componentName) == false) {
                app.component(
                    componentName,
                    defineAsyncComponent(() => import(`./components/${componentPath}.vue`)),
                );

                // Save the component name so that the registration is not overwritten later on.
                alreadyRegisteredList.push(componentName);
            }
        });
}
